import L from 'leaflet';
import { toLatLng as latLng } from 'leaflet/src/geo/LatLng';

const AddressLayer = L.Marker.extend({
    options: {
        zIndexOffset: -1000,
        pane: 'addresses',
    },

    initialize(latlng, options) {
        this._options = L.Util.setOptions(this, options);
        this._latlng = latLng(latlng);
    },
    onAdd(map) {
        const pane = this.getPane();
        if (!pane) {
            map.createPane('addresses');
        }

        return L.Marker.prototype.onAdd.call(this, map);
    },

    on(name, handler) {
        return this;
    },
});

export default AddressLayer;
